import { LegalScreen } from "@/components/legalPolicies";
import MainLayout from "@/layouts/MainLayout";

import { useTheme } from "@cellectenergy/cellect-react-components";

const Legal = () => {
  const theme = useTheme();
  return (
    <MainLayout
      bgTheme={theme.palette.common.corporateColors.primary.midNightBlue}
      navbarTheme="light"
      title="Legal Policies"
      description="Legal is a page where the client can read the legal information about the product/services"
    >
      <LegalScreen />
    </MainLayout>
  );
};
export default Legal;
